module.exports = __webpack_public_path__ + "assets/img/sketch.7420f4b7.jpg";